// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mapstyles_mapcontainer__iQFL4 {
  padding: 0px 17px 0px 30px;
   height: 600px;
    
     width: 100%;
  
    /* max-width: 1024px;  */
    float: right;
    border-radius: 25px;
    position: relative;

  }
  h4{
    margin: 0;
  }
  .mapstyles_mapref__rpRD8 {
    height: 100%;
    border-radius: 15px;
  }
  
  .mapstyles_btn__scuxj {
    font-size: 30px;
  }
  
  .mapstyles_inputcommunitys__tSW9F{
    position: relative;
    outline: none;
    padding: 9px;
    border: none;
    width: 100%;
    /* max-width: 319px; */
    border-radius: 25px;
    box-shadow: 0px 2px 4px  black;
    margin: 3px 0px 3px 4px;
  }

  .mapstyles_communitymapimage__S6K1T{
    display: flex;
  }

  .mapstyles_communityinmap__y1bdS{
    /* max-width: 192px; */
    /* width: auto; */
    margin: 14px 0px 0px 5px;
    border-radius: 25px;
    box-shadow: 2px 3px 6px lightgray;
    font-size: small;
  }

  .mapstyles_communitycontent__wFdlg{
    padding: 14px;
  }

  .mapstyles_communitymapimage__S6K1T>button{
    border: none;
    outline: none;
    box-shadow: 2px 3px 3px lightgrey;
    margin-right: 2px;
    color: #4795DE;
    font-size: 11px;
    font-weight: 500;
    border-radius: 12px;
    padding:6px;
  }
  .mapstyles_FocusAppearence__3lGGK{
    /* box-shadow:2px 4px 4px 2px #4795DE; */
   border: solid #4795DE !important;

    /* border:5px solid lightblue; */
  }

  .mapstyles_communityfolder__KmQmR{
    position: absolute ;
    outline: none !important;
    border: none !important;
    z-index: 2;
    right: 16px;
    top:4px;
    bottom: 1px;
background-color:white;    
    border-radius: 20px;
    max-height: 40px;
    /* padding-right: 8px; */
  }
 
  .mapstyles_maprow__YepRv{
    width: 100%;
  }

  .mapstyles_startcommunity__AjceX{

    background-color: white;
    display: flex;
position: absolute;
    max-width: min-content;
    padding: 15px;
    border-radius: 25px;
    float: left;
    left: 60px;
    bottom: 90px;
  }

  .mapstyles_countrytag__M0UH0{
position: absolute;
    background: white;
    border-radius: 50%;
    width: 80px;
    height: 80px;
    right: 80px;
    bottom: 97px;
    padding: 17px 0px 0px 22px;
  }

  .mapstyles_countrytag__M0UH0>p{
    margin-bottom: -9px;
  }

  .mapstyles_headerforsignin__T\\+UD6{
    display: flex;
        justify-content: space-between;
        align-items: center;
  }

  @media  (max-width: 768px) {
    .mapstyles_communityinmap__y1bdS{
    width: 100%;
    min-width: 250px;
    }
    }
    @media  (max-width: 375px){
    .mapstyles_startcommunity__AjceX{
      left: 35px;
      bottom: 162px;

    }
    .mapstyles_countrytag__M0UH0{
      right: 211px;
      bottom: 73px;

    }
    }
  /* div:nth-child(5){
  margin-bottom: 50px;
  } */

@media  (max-width: 425px){
.mapstyles_headerforsignin__T\\+UD6{
display: unset;
}
}`, "",{"version":3,"sources":["webpack://./src/Assets/css/maps/mapstyles.module.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;GACzB,aAAa;;KAEX,WAAW;;IAEZ,wBAAwB;IACxB,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;;EAEpB;EACA;IACE,SAAS;EACX;EACA;IACE,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,sBAAsB;IACtB,mBAAmB;IACnB,8BAA8B;IAC9B,uBAAuB;EACzB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,iBAAiB;IACjB,wBAAwB;IACxB,mBAAmB;IACnB,iCAAiC;IACjC,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,iCAAiC;IACjC,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;EACb;EACA;IACE,wCAAwC;GACzC,gCAAgC;;IAE/B,gCAAgC;EAClC;;EAEA;IACE,mBAAmB;IACnB,wBAAwB;IACxB,uBAAuB;IACvB,UAAU;IACV,WAAW;IACX,OAAO;IACP,WAAW;AACf,sBAAsB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,wBAAwB;EAC1B;;EAEA;IACE,WAAW;EACb;;EAEA;;IAEE,uBAAuB;IACvB,aAAa;AACjB,kBAAkB;IACd,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,UAAU;IACV,YAAY;EACd;;EAEA;AACF,kBAAkB;IACd,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,0BAA0B;EAC5B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;QACT,8BAA8B;QAC9B,mBAAmB;EACzB;;EAEA;IACE;IACA,WAAW;IACX,gBAAgB;IAChB;IACA;IACA;IACA;MACE,UAAU;MACV,aAAa;;IAEf;IACA;MACE,YAAY;MACZ,YAAY;;IAEd;IACA;EACF;;KAEG;;AAEL;AACA;AACA,cAAc;AACd;AACA","sourcesContent":[".mapcontainer {\r\n  padding: 0px 17px 0px 30px;\r\n   height: 600px;\r\n    \r\n     width: 100%;\r\n  \r\n    /* max-width: 1024px;  */\r\n    float: right;\r\n    border-radius: 25px;\r\n    position: relative;\r\n\r\n  }\r\n  h4{\r\n    margin: 0;\r\n  }\r\n  .mapref {\r\n    height: 100%;\r\n    border-radius: 15px;\r\n  }\r\n  \r\n  .btn {\r\n    font-size: 30px;\r\n  }\r\n  \r\n  .inputcommunitys{\r\n    position: relative;\r\n    outline: none;\r\n    padding: 9px;\r\n    border: none;\r\n    width: 100%;\r\n    /* max-width: 319px; */\r\n    border-radius: 25px;\r\n    box-shadow: 0px 2px 4px  black;\r\n    margin: 3px 0px 3px 4px;\r\n  }\r\n\r\n  .communitymapimage{\r\n    display: flex;\r\n  }\r\n\r\n  .communityinmap{\r\n    /* max-width: 192px; */\r\n    /* width: auto; */\r\n    margin: 14px 0px 0px 5px;\r\n    border-radius: 25px;\r\n    box-shadow: 2px 3px 6px lightgray;\r\n    font-size: small;\r\n  }\r\n\r\n  .communitycontent{\r\n    padding: 14px;\r\n  }\r\n\r\n  .communitymapimage>button{\r\n    border: none;\r\n    outline: none;\r\n    box-shadow: 2px 3px 3px lightgrey;\r\n    margin-right: 2px;\r\n    color: #4795DE;\r\n    font-size: 11px;\r\n    font-weight: 500;\r\n    border-radius: 12px;\r\n    padding:6px;\r\n  }\r\n  .FocusAppearence{\r\n    /* box-shadow:2px 4px 4px 2px #4795DE; */\r\n   border: solid #4795DE !important;\r\n\r\n    /* border:5px solid lightblue; */\r\n  }\r\n\r\n  .communityfolder{\r\n    position: absolute ;\r\n    outline: none !important;\r\n    border: none !important;\r\n    z-index: 2;\r\n    right: 16px;\r\n    top:4px;\r\n    bottom: 1px;\r\nbackground-color:white;    \r\n    border-radius: 20px;\r\n    max-height: 40px;\r\n    /* padding-right: 8px; */\r\n  }\r\n \r\n  .maprow{\r\n    width: 100%;\r\n  }\r\n\r\n  .startcommunity{\r\n\r\n    background-color: white;\r\n    display: flex;\r\nposition: absolute;\r\n    max-width: min-content;\r\n    padding: 15px;\r\n    border-radius: 25px;\r\n    float: left;\r\n    left: 60px;\r\n    bottom: 90px;\r\n  }\r\n\r\n  .countrytag{\r\nposition: absolute;\r\n    background: white;\r\n    border-radius: 50%;\r\n    width: 80px;\r\n    height: 80px;\r\n    right: 80px;\r\n    bottom: 97px;\r\n    padding: 17px 0px 0px 22px;\r\n  }\r\n\r\n  .countrytag>p{\r\n    margin-bottom: -9px;\r\n  }\r\n\r\n  .headerforsignin{\r\n    display: flex;\r\n        justify-content: space-between;\r\n        align-items: center;\r\n  }\r\n\r\n  @media  (max-width: 768px) {\r\n    .communityinmap{\r\n    width: 100%;\r\n    min-width: 250px;\r\n    }\r\n    }\r\n    @media  (max-width: 375px){\r\n    .startcommunity{\r\n      left: 35px;\r\n      bottom: 162px;\r\n\r\n    }\r\n    .countrytag{\r\n      right: 211px;\r\n      bottom: 73px;\r\n\r\n    }\r\n    }\r\n  /* div:nth-child(5){\r\n  margin-bottom: 50px;\r\n  } */\r\n\r\n@media  (max-width: 425px){\r\n.headerforsignin{\r\ndisplay: unset;\r\n}\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mapcontainer": `mapstyles_mapcontainer__iQFL4`,
	"mapref": `mapstyles_mapref__rpRD8`,
	"btn": `mapstyles_btn__scuxj`,
	"inputcommunitys": `mapstyles_inputcommunitys__tSW9F`,
	"communitymapimage": `mapstyles_communitymapimage__S6K1T`,
	"communityinmap": `mapstyles_communityinmap__y1bdS`,
	"communitycontent": `mapstyles_communitycontent__wFdlg`,
	"FocusAppearence": `mapstyles_FocusAppearence__3lGGK`,
	"communityfolder": `mapstyles_communityfolder__KmQmR`,
	"maprow": `mapstyles_maprow__YepRv`,
	"startcommunity": `mapstyles_startcommunity__AjceX`,
	"countrytag": `mapstyles_countrytag__M0UH0`,
	"headerforsignin": `mapstyles_headerforsignin__T+UD6`
};
export default ___CSS_LOADER_EXPORT___;
